module.exports = __webpack_public_path__ + "img/ecopayz.d7ca41ca.svg";